import React from 'react';
import Vehicles from '../components/fleet/Vehicles';

const FleetManagement: React.FC = () => {
  return <Vehicles />;
};

export default FleetManagement;
